
  import React from "react"
  import Component from "C:/Users/kyriez_sbh/Desktop/gender bias education/_autocomplete lab/ai-gender-bias/src/layouts/index.js"
  import data from "C:\\Users\\kyriez_sbh\\Desktop\\gender bias education\\_autocomplete lab\\ai-gender-bias\\.cache\\json\\layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js